import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import "./styles.css";
import Item from "./item";

const Picking = (props) => {
  const dragItem = useRef();
  const dragOverItem = useRef();
  const [itemsSubRubrosPicking, setItemsSubRubrosPicking] = useState([]);

  const dragStart = (position) => {
    dragItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const dragEnter = (position) => {
    dragOverItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const drop = () => {
    const copyListItems = [...itemsSubRubrosPicking];
    const dragItemContent = copyListItems[dragItem.current];
    const dragOverItemContent = copyListItems[dragOverItem.current];
    copyListItems.splice(dragItem.current, 1); //se borra
    copyListItems.splice(dragItem.current, 0, dragOverItemContent);
    copyListItems.splice(dragOverItem.current, 1); //se borra
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;

    props.handleOnSwap(
      copyListItems.map((x) => x.idSubrubro.toString()),
      props.subRubros[0].idRubro
    );

    setItemsSubRubrosPicking(copyListItems);
  };

  if (itemsSubRubrosPicking.length !== props.subRubros.length) {
    setItemsSubRubrosPicking(
      props.subRubros.map((x) => ({
        idSubrubro: x.idSubrubro,
        nombre: x.nombre,
        imagen: x.imagen,
        nombreRubro: x.nombreRubro,
      }))
    );
  }

  return (
    <>
      {/* menú superior */}
      <TitleBar title={"Picking"} />

      <div className="subtitulo">Orden de subrubros en góndola</div>

      <Row style={{ margin: "0px" }} className="draggable">
        {itemsSubRubrosPicking &&
          itemsSubRubrosPicking.map((item, index) => (
            <Col
              md={6}
              lg={4}
              onDragStart={() => dragStart(index)}
              onDragEnter={() => dragEnter(index)}
              onDragEnd={drop}
              key={index}
              className="draggable"
              draggable
            >
              <Item item={item} {...props}></Item>
            </Col>
          ))}
      </Row>
      {(props.subRubros === undefined || props.subRubros.length === 0) && (
        <div className="labelNoResultados">No se encontraron subrubros activos</div>
      )}
    </>
  );
};

Picking.propTypes = {
  subRubros: PropTypes.array,
  handleOnSwap: PropTypes.func,
  loading: PropTypes.bool,
};

Picking.defaultProps = {
  subRubros: [],
  handleOnSwap: (f) => f,
  loading: false,
};

export default Picking;
